const getYears = (amount, year) =>
  Array.from({ length: amount }, (value, index) => {
    const currentYear = new Date().getFullYear();
    const yearNumber = year && year < currentYear ? index + year : index + currentYear;
    return { id: yearNumber, name: yearNumber.toString() };
  });

export default getYears;
